import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { BREAKPOINTS_WIDTH_MAP, NEXT_BREAKPOINT_MAP, BREAKPOINTS_KEYS } from '../breakpoints';

var capitalizeString = function capitalizeString(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};
/**
 * [Stitches Utils](https://stitches.dev/docs/utils) for targeting all breakpoints with "upTo" logic
 * i.e: apply rules only when exactly in this breakpoint
 */


var generateOnBreakpointUtils = function generateOnBreakpointUtils() {
  return BREAKPOINTS_KEYS.reduce(function (acc, breakpoint) {
    var min = BREAKPOINTS_WIDTH_MAP[breakpoint] + 'px';
    var mediaQuery = "@media (min-width: ".concat(min, ")");
    var nextBreakpoint = NEXT_BREAKPOINT_MAP[breakpoint];

    if (nextBreakpoint) {
      var max = BREAKPOINTS_WIDTH_MAP[nextBreakpoint] - 1 + 'px';
      mediaQuery += " and (max-width: ".concat(max, ")");
    }

    acc["on".concat(capitalizeString(breakpoint))] = function (styles) {
      return _defineProperty({}, mediaQuery, styles);
    };

    return acc;
  }, {});
};
/**
 * [Stitches Utils](https://stitches.dev/docs/utils) for targeting all breakpoints with "upTo" logic
 * i.e: ignore rules before this breakpoint
 */


var generateFromBreakpointUtils = function generateFromBreakpointUtils() {
  return BREAKPOINTS_KEYS.reduce(function (acc, breakpoint) {
    acc["from".concat(capitalizeString(breakpoint))] = function (styles) {
      return _defineProperty({}, "@".concat(breakpoint), styles);
    };

    return acc;
  }, {});
};
/**
 * [Stitches Utils](https://stitches.dev/docs/utils) for targeting all breakpoints with "upTo" logic
 * i.e: ignore rules after this breakpoint
 */


var generateUpToBreakpointUtils = function generateUpToBreakpointUtils() {
  return BREAKPOINTS_KEYS.reduce(function (acc, breakpoint) {
    var max = BREAKPOINTS_WIDTH_MAP[breakpoint] - 1 || 1; // media query with max width 0 leads to weird bugs

    acc["upTo".concat(capitalizeString(breakpoint))] = function (styles) {
      return _defineProperty({}, "@media (max-width: ".concat(max, "px)"), styles);
    };

    return acc;
  }, {});
};
/**
 * Generate variants for all targetable breakpoints ("upToXs", "fromMd", "onXl", etc.)
 * This is used by the Hide component to generate all possible variants.
 */


var generateBreakpointsVariants = function generateBreakpointsVariants(style) {
  var prefixes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['upTo', 'from', 'on'];
  var variants = {};

  var _iterator = _createForOfIteratorHelper(prefixes),
      _step;

  try {
    var _loop = function _loop() {
      var prefix = _step.value;
      BREAKPOINTS_KEYS.forEach(function (breakpoint) {
        // upToXs, fromMd, etc.
        var variantKey = "".concat(prefix).concat(capitalizeString(breakpoint));
        variants[variantKey] = {
          "true": _defineProperty({}, variantKey, style)
        };
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return variants;
};
/**
 * Generates variants for all keys of "variants" and maps its value to the css attribute
 */


function mapObjectToCSSVariants(variants, cssAttribute) {
  return Object.keys(variants).reduce(function (acc, key) {
    acc[key] = _defineProperty({}, cssAttribute, variants[key]);
    return acc;
  }, {});
}
/**
 * Generate `GridItem` variants to enable sizing based on breakpoints variants. e.g: `<GridItem xs={12} md={6} xl={3} />`
 */


var generateGridResponsiveSizeVariants = function generateGridResponsiveSizeVariants() {
  var variants = {
    xs: {},
    sm: {},
    md: {},
    lg: {},
    xl: {},
    xxl: {}
  };
  BREAKPOINTS_KEYS.forEach(function (breakpoint) {
    Array.from({
      length: 12
    }).forEach(function (_, index) {
      var column = index + 1;
      var target = "from".concat(capitalizeString(breakpoint));

      if (!variants[breakpoint][column]) {
        variants[breakpoint][column] = {};
      }

      if (!variants[breakpoint][column][target]) {
        variants[breakpoint][column][target] = {};
      }

      variants[breakpoint][column][target] = {
        gridColumn: "span ".concat(column)
      };
    });
  });
  return variants;
};
/**
 * Generate `GridItem` variants to automatically center columns. These variants will only work with 12 columns grid
 */


var generateGridCenteredVariants = function generateGridCenteredVariants() {
  var variants = [];
  var centralizeableSizes = [2, 4, 6, 8, 10, 12];
  BREAKPOINTS_KEYS.forEach(function (breakpoint) {
    centralizeableSizes.forEach(function (size) {
      var _variants$push;

      // Calculate on which column we have to start in order to have it centralized on the grid
      var columnStart = (12 - size) / 2 + 1;
      var target = "from".concat(capitalizeString(breakpoint));
      variants.push((_variants$push = {}, _defineProperty(_variants$push, breakpoint, size), _defineProperty(_variants$push, "centerEvenSizedColumn", true), _defineProperty(_variants$push, "css", _defineProperty({}, target, {
        textAlign: 'center',
        gridColumnStart: columnStart,
        gridColumnEnd: columnStart + size
      })), _variants$push));
    });
  });
  return variants;
};

export { capitalizeString, generateFromBreakpointUtils, generateOnBreakpointUtils, generateUpToBreakpointUtils, generateBreakpointsVariants, generateGridCenteredVariants, generateGridResponsiveSizeVariants, mapObjectToCSSVariants };